var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormInput',{attrs:{"name":"id","label":_vm.label,"helper":_vm.helper,"error":_vm.error,"validation":_vm.validation},on:{"input":_vm.onInput},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }